<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps"/>
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="content-input-default">
            <input type="text" name="name" v-model="plan.name" value="" placeholder="Nome" required/>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default-select" :class="{'content-input-default-select--active': selectedCategory && selectedCategory !== ''}">
            <select v-model="selectedCategory" required>
              <option value="" selected disabled>Selecione a categoria</option>
              <option v-for="category in plansCategories" :key="category.id" :value="category.id">{{ category.name }}</option>
            </select>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_35_1490" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12" style="mask-type: luminance;"><path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"></path></mask><g mask="url(#mask0_35_1490)"><path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"></path></g></svg>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default">
            <input type="text" name="title" v-model="plan.title" value="" placeholder="Título" required/>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <textarea name="description" v-model="plan.description" value="" placeholder="Descrição curta" style="min-height: 150px" required></textarea>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <quill-editor v-model="plan.contentHtml" ref="refQuillEditor" :options="quillOptions"></quill-editor>
          </div>
        </div>
        <div class="col-12">
          <UploadImage @changePicture="(value) => plan.picture = value"/>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import UploadImage from '@/components/upload/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Planos',
          routerName: 'Plans'
        },
        {
          name: 'Novo Plano',
          routerName: 'RegisterPlans'
        },
      ],
      plan: {
        id_user: "",
        name: '',
        title: '',
        description: '',
        contentHtml: '',
        picture: null,
      },
      quillOptions: {
        placeholder: 'Descreva as informações completa sobre o plano',
        readonly: false,
      },
      planParams: this.$route.params,
      selectedCategory: '',
      dataProps: { module: 'Plans' },
    }
  },
  computed: {
    ...mapGetters({
      user: 'User/user',
      planData: 'Plans/plan',
      plansCategories: 'Plans/plansCategories',
      isPremium: 'Plans/isPremium'
    })
  },
  components: {
    Breadcrumb,
    UploadImage
  },
  methods: {
    ...mapActions('Plans', ['consultCategoriesPlans', 'registerPlan', 'consultPlans', 'setDataDefault']),
    ...mapActions(['setImageFileUrl']),
    async handleSubmit(){
      let message = this.plan?.id ? 'Plano editado com sucesso!' : 'Plano cadastrado com sucesso!';

      this.plan.id_plan_category = this.selectedCategory;
      this.plan.is_premium = this.isPremium;

      await this.registerPlan(this.plan);
      this.$router.push({ name: 'Plans' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
  },
  async mounted() {
    this.consultCategoriesPlans();
    this.plan.id_user = await this.user.id;
    this.setImageFileUrl(null);
    if (this.planParams && Object.keys(this.planParams).length > 0) {
      await this.consultPlans(this.planParams);
      this.dataProps = { name: 'Plano', id: this.planParams.id, module: 'Plans' };
      this.plan = this.planData;
      this.setDataDefault(['SET_IS_PREMIUM', this.plan.is_premium]);
      this.selectedCategory = this.plan.id_plan_category;
      this.links[1].name = this.plan.name;
      this.setImageFileUrl(this.plan.picture);
    }
  }
}
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
